import { Image, Modal } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  width: 100%;
  height: 56.25rem;
  overflow: hidden;
  max-width: 46.75rem !important;
  box-sizing: border-box;

  .ant-modal-close {
    transition: none !important;
    top: 1rem;
    right: 1rem;

    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.default} !important;

    background-color: transparent;
    transition:
      background-color 0.3s ease,
      color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.neutralLight} !important;
    }
  }

  .ant-modal-close-x,
  .anticon.anticon-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
  }

  .ant-modal-container {
    padding: 1.25rem 1.5rem;
  }

  .ant-modal-container,
  .ant-carousel {
    box-sizing: border-box;
  }
`;

export const StyledTitle = styled.h1`
  margin-top: 0.75rem;
  margin-bottom: 1.125rem;
  margin-right: 1.5rem;
  text-align: center;
  line-height: 1.2;
  font-size: 1.75rem;
`;

export const StyledParagraph = styled.div`
  margin: 0.5rem;
  font-size: 1rem;
  line-height: 1.4;
  text-align: justify;
  max-height: 2.8125rem;
  overflow-y: auto;
  scrollbar-gutter: stable;
`;

export const StyledDescriptionParagraphContainer = styled(StyledParagraph)`
  margin-bottom: 1rem;
  overflow-y: auto;
  scrollbar-gutter: stable;
  max-height: 12.5rem;
`;

export const StyledDescriptionParagraph = styled.div`
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
  text-align: justify;
  white-space: pre-line;
  text-indent: 1.25rem;
`;

export const StyledCarouselContainer = styled.div`
  width: 43.75rem;
  height: 25.625rem;
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const StyledImage = styled(Image)`
  width: 43.75rem !important;
  height: 25.625rem !important;
  object-fit: cover;
  object-position: center;
  border-radius: 0.5rem;
  display: block;
`;
